import { configureStore } from '@reduxjs/toolkit';
import activeComponentReducer from './Slices/activeComponentSlice';
import userDetailsReducer from './Slices/userDetailsSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // This uses localStorage by default
import dashboardActiveComponentReducer from './Slices/dashboardActiveComponent';
import certificationReducer from './Slices/certificationSlice';
import featureFlagsReducer from './Slices/featureFlagsSlice';

const persistConfig = {
  key: 'root',
  storage, // You can use sessionStorage by changing this to 'sessionStorage'
};

// Create separate persist configs for each reducer
const activeComponentPersistConfig = {
  ...persistConfig,
  key: 'activeComponent',
};

const userDetailsPersistConfig = {
  ...persistConfig,
  key: 'userDetails',
};

const dashboardActiveComponentPersistConfig = {
  ...persistConfig,
  key: 'dashboardActiveComponent',
};

const featureFlagsPersistConfig = {
  ...persistConfig,
  key: 'featureFlags',
};

const persistedActiveComponentReducer = persistReducer(activeComponentPersistConfig, activeComponentReducer);
const persistedUserDetailsReducer = persistReducer(userDetailsPersistConfig, userDetailsReducer);
const persistedDashboardActiveComponentReducer = persistReducer(dashboardActiveComponentPersistConfig, dashboardActiveComponentReducer);
const persistedFeatureFlagsReducer = persistReducer(featureFlagsPersistConfig, featureFlagsReducer);

const store = configureStore({
  reducer: {
    activeComponent: persistedActiveComponentReducer,
    userDetails: persistedUserDetailsReducer,
    dashboardActiveComponent: persistedDashboardActiveComponentReducer,
    certification: certificationReducer,
    featureFlags: persistedFeatureFlagsReducer,
  },
});

export const persistor = persistStore(store);

export default store;
